import * as ActionTypes from '../../actions/ActionTypes';
import ScreenshotDetailsRecord from '../../records/insights/ScreenshotDetailsRecord';
import ScreenshotRecord from '../../records/insights/ScreenshotRecord';
export default function screenShotDetailsInfo(state = new ScreenshotDetailsRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_SCREENSHOT_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_SCREENSHOT_SUCCESS:
      return state.merge({
        isRequesting: false,
        screenshot: new ScreenshotRecord(action.payload),
        error: undefined
      });
    case ActionTypes.FETCH_SCREENSHOT_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    default:
      return state;
  }
}